/* Static markup of the approved artist interview page (03 Website Redesign/artist-interview.html). */
export const INTERVIEW_HTML = `
<div class="topbar"><div class="brand">TRIP <b>INK</b> TATTOO</div><div class="tag"><a href="/" style="color:inherit;text-decoration:none;border-bottom:1px solid currentColor">&larr; Back to Trip Ink</a> &nbsp;&middot;&nbsp; Las Vegas &middot; Artist Interview</div></div>
<main>

<section id="s-welcome" class="screen active">
  <div class="hero card">
    <div>
      <h1>Let's talk <span>ink.</span></h1>
      <p class="lead">Rick asked us to get to know you. We want to send you clients who want exactly what you do best. It takes about 10 to 12 minutes. You will answer 12 questions. For each one, you can record a video, record your voice, or just type.</p>
      <p class="lead">At the end you will add your best photos and a few details. Do it on your phone or on a computer. Whatever is easy.</p>
    </div>
    <div>
      <label for="artistName">Your name</label>
      <input type="text" id="artistName" autocomplete="name" placeholder="First and last name">
      <label for="artistIG">Your Instagram</label>
      <input type="text" id="artistIG" autocapitalize="none" autocorrect="off" placeholder="@yourhandle">
      <div class="err" id="welcomeErr" role="alert"></div>
      <div class="row" style="margin-top:1rem"><button class="btn" id="startBtn">Start the interview</button></div>
      <p class="note">Tip: find a quiet spot with good light. You can skip any question and come back to it.</p>
    </div>
  </div>
</section>

<section id="s-interview" class="screen">
  <div class="card">
    <div class="progress">
      <div class="txt"><span id="progText">Question 1 of 12</span><span id="progPct">0%</span></div>
      <div class="bar"><i id="progBar"></i></div>
      <div class="dots" id="dots"></div>
    </div>
    <div class="qwrap">
      <div>
        <div class="qnum display" id="qnum">Question 1</div>
        <h2 class="qtext" id="qtext"></h2>
        <p class="hint" id="qhint"></p>
      </div>
      <div>
        <div class="tabs" role="tablist" aria-label="How do you want to answer?">
          <button class="tab" role="tab" data-mode="video" aria-selected="true">Record video</button>
          <button class="tab" role="tab" data-mode="audio" aria-selected="false">Record audio only</button>
          <button class="tab" role="tab" data-mode="text" aria-selected="false">Type it</button>
        </div>
        <div class="panel active" id="p-video"></div>
        <div class="panel" id="p-audio"></div>
        <div class="panel" id="p-text">
          <label for="typed" class="lbl" style="margin-top:0">Your answer</label>
          <textarea id="typed" placeholder="Type your answer here..."></textarea>
        </div>
        <div class="note" id="answerState"></div>
      </div>
    </div>
    <div class="nav">
      <button class="btn ghost" id="backBtn">Back</button>
      <button class="btn ghost" id="skipBtn">Skip</button>
      <span class="spacer"></span>
      <button class="btn" id="nextBtn">Next</button>
    </div>
  </div>
</section>

<section id="s-form" class="screen">
  <div class="card">
    <h1 style="font-size:clamp(2rem,4.5vw,5rem);line-height:1">Last step: <span style="color:var(--red2)">your work</span></h1>
    <p class="lead">Almost done. Tell us what you do, your rates, your open dates, and add your best photos.</p>
    <div class="fgrid" style="margin-top:1.2rem">

      <div class="fsec">
        <h3>Styles I love doing</h3>
        <p class="note">Tap all that apply.</p>
        <div class="chips" id="chipsDo"></div>
        <label for="otherStyle">Another style not listed</label>
        <input type="text" id="otherStyle" placeholder="Type it here">
      </div>

      <div class="fsec">
        <h3>Styles I won't do</h3>
        <p class="note">Tap anything you would rather pass on.</p>
        <div class="chips no" id="chipsNo"></div>
        <label for="noNotes">Anything else you pass on</label>
        <input type="text" id="noNotes" placeholder="Example: no faces, no names on hands">
      </div>

      <div class="fsec">
        <h3>My rates</h3>
        <div class="two">
          <div><label for="dayRate">Day rate ($)</label><input type="number" inputmode="decimal" min="0" id="dayRate" placeholder="e.g. 1500"></div>
          <div><label for="halfRate">Half-day rate ($)</label><input type="number" inputmode="decimal" min="0" id="halfRate" placeholder="e.g. 800"></div>
        </div>
      </div>

      <div class="fsec">
        <h3>Open dates, Oct to Dec</h3>
        <p class="note">Tap the days you can work, or just write it below.</p>
        <div id="monthPicker"></div>
        <label for="datesNotes">Dates in your own words</label>
        <textarea id="datesNotes" style="min-height:5rem" placeholder="Example: Tuesdays and Thursdays in October, all of December except the 20th to 27th"></textarea>
      </div>

      <div class="fsec span-all">
        <h3>My portfolio photos</h3>
        <p class="note">Add 10 to 20 of your best pieces. Pick a style and where it is on the body for each one.</p>
        <div class="drop">
          <input type="file" id="photoInput" accept="image/*" multiple>
          <p class="note" style="margin:.5rem 0 0">On a phone you can pick from your camera roll.</p>
        </div>
        <div class="note" id="photoCount">0 photos added. Aim for 10 to 20.</div>
        <div class="photos" id="photos"></div>
      </div>

      <div class="fsec span-all">
        <h3>Tattoos I can do</h3>
        <p class="note">One idea per line. Examples: a rose, a portrait, a sleeve, a cover-up, a name in script.</p>
        <textarea id="canDo" placeholder="Rose&#10;Koi fish&#10;Black and grey portrait"></textarea>
      </div>

      <div class="fsec span-all">
        <label class="check"><input type="checkbox" id="consent"><span>Yes, Trip Ink can feature my work in Trip Ink ads. Please tag my name and my Instagram.</span></label>
        <div class="err" id="formErr" role="alert"></div>
      </div>
    </div>
    <div class="nav">
      <button class="btn ghost" id="formBack">Back to questions</button>
      <span class="spacer"></span>
      <button class="btn" id="submitBtn">Submit</button>
    </div>
  </div>
</section>

<section id="s-thanks" class="screen">
  <div class="card thanks">
    <h1>Thanks, <span id="thanksName">artist</span>!</h1>
    <p class="lead" style="margin:1rem auto">Your answers are in. Rick and the Trip Ink team will look at everything and be in touch.</p>
    <p class="note" id="thanksNote"></p>
    <div class="row" style="justify-content:center;margin-top:1rem">
      <button class="btn ghost" id="dlAgain">Download my answers again</button>
    </div>
  </div>
</section>
</main>
`;
